import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-pilates': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-female-pilates&exp=web_pilates_plan_preview_before_paywall~1
			funnel: {
				id: 'ob-pilates-plan-preview-before-paywall',
				locale: ['en'],
			},
		},
	},
]

export default config
